import { BubbleGameBoard } from 'js/bubbleCore/BubbleGameBoard';
import { createShooterUpdatedEvent } from 'js/bubbleCore/events';

export function createFireBubble(board: BubbleGameBoard): void {
  board.getData().shooter.bubblesQueue[0] = board.getFactory().createFire(0, 0);
  board.getEventsQueue().push(createShooterUpdatedEvent(board.getData().shooter));
}